module.exports = __webpack_public_path__ + "static/media/PM120.c6a183b9.png";